<template>
  <div class="hello">

  </div>
</template>

<script>
import {} from '../api/api'
export default {
  name: '',
  data () {
    return {
     
    }
  },
  created(){

  },
  methods:{

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue